<template>
  <div class="regardDH">
    <comHead :tabIndexI="5" :imgSrc="imgSrc" />
    <div class="aboutCenter" id="position6-1">
      <div class="aboutUs">
        <div class="aboutTitle">
          <h1>鼎宏简介</h1>
          <div class="english">Dinghong profile</div>
        </div>
        <div class="describe">
          <p>
            鼎宏集团于2009年成立，是国内知名的知识产权全产业链品牌服务机构。秉承“鼎兴中国知识产权，宏扬中华民族品牌”的伟大使命，紧跟国家战略部署，
            围绕知识产权创造、运用、保护、管理和服务，积极投身于知识产权事业建设。
          </p>
          <p>
            鼎宏集团是国家中小企业公共服务示范平台、中华商标协会理事单位、中国版权协会理事单位、中国专利保护协会副会长单位、全国商标代理服务金牌示
            范单位、中西部各省知识产权协会、商标协会、地标协会会长/副会长单位。
          </p>
          <p>
            鼎宏集团旗下拥有22家子公司及战略单位，包括知识产权代理公司、专利事务所、律师事务所、科技服务公司、品牌咨询公司、评估咨询公司、品牌研
            究院等。同时，设置三大运营中心，600余人专家服务团队，为30余万客户提供专业服务。
          </p>
          <p>
            鼎宏集团服务范围涵盖8大领域，包括知识产权代理服务、知识产权法律服务、知识产权咨询服务、知识产权运营服务、知识产权信息化服务、互联网与科技应用服务、品牌运营服务、培训服务等。
          </p>
          <p>
            我们坚持“以客户为中心，为客户创造价值”的服务理念，与南方电网、昆钢集团、褚橙、中国国际大数据产业博览会、长虹集团、舍得酒业、好医生、
            中南钻石、西安交通大学、四川大学、重庆大学等知名企业和高校建立战略合作关系。
          </p>
          <p>
            着眼未来，鼎宏集团正在用实际行动为加快知识产权转移转化，赋能经济社会高质量发展而不懈奋斗，推动中国知识产权事业不断向前，为新时代知识产权强国建设贡献力量。
          </p>
        </div>
      </div>
      <div class="videoFrequency">
        <div class="aboutPhoto">
          <img src="../../static/imgs/regardDH/gognsi.jpg" alt="" />
        </div>
        <video :src="require('../../static/movie/鼎宏集团最新宣传片.mp4')" class="aboutVideo" autoplay controls
          id="dhVideo" preload="auto"></video>
      </div>
    </div>
    <div class="missionBg" id="position6-2">
      <ul class="missionCenter">
        <li class="mission">
          <div class="missionPhoto">
            <img src="../../static/imgs/regardDH/shiming.jpg" alt="" />
          </div>
          <div class="missionDescribe">
            <img class="left" src="../../static/imgs/regardDH/sanjiao.png" alt="" />
            <h1>使命</h1>
            <div class="xiantiao"></div>
            <div>鼎兴中国知识产权 · 宏扬中华民族品牌</div>
          </div>
        </li>
        <li class="mission">
          <div class="missionPhoto">
            <img src="../../static/imgs/regardDH/pinpai.jpg" alt="" />
          </div>
          <div class="missionDescribe">
            <img class="left" src="../../static/imgs/regardDH/sanjiao.png" alt="" />
            <h1>品牌定位</h1>
            <div class="xiantiao"></div>
            <div>中国知识产权全产业链品牌服务机构</div>
          </div>
        </li>
        <li class="mission">
          <div class="missionDescribe">
            <img class="right" src="../../static/imgs/regardDH/right.png" alt="" />
            <h1>愿景</h1>
            <div class="xiantiao"></div>
            <div>以知识产权创新服务筑造企业更美好的未来，成就中国品牌梦想</div>
          </div>
          <div class="missionPhoto">
            <img src="../../static/imgs/regardDH/yuanjing.jpg" alt="" />
          </div>
        </li>
        <li class="mission">
          <div class="missionDescribe">
            <img class="right" src="../../static/imgs/regardDH/right.png" alt="" />
            <h1>核心价值观</h1>
            <div class="xiantiao"></div>
            <div>诚信务实、专业高效、创新进取、协作共赢、持续奋斗</div>
          </div>
          <div class="missionPhoto">
            <img src="../../static/imgs/regardDH/jiazhiguan.jpg" alt="" />
          </div>
        </li>
      </ul>
    </div>
    <div class="honor" id="position6-3">
      <img src="../../static/imgs/regardDH/rongyu.jpg" alt="" />
    </div>
    <div class="matrixConcent" id="position6-4">
      <div class="matrixTitle">
        <h1>集团矩阵</h1>
      </div>
      <div class="matrixBody">
        <div class="matrixParagraph">
          <p>
            线上+线下交易服务平台+智库平台联动，以期实现多领域的人才联合、智力联合、资源整合，帮助合作伙伴明确战略，发展创新，提高整体竞争优势，助力企业实现高质量发展
          </p>
        </div>
        <ul class="classify">
          <li class="classification1">
            <div class="numberTotal">
              <div class="number">1</div>
              <div class="squad">个集团</div>
            </div>
            <div class="battleArray">鼎宏集团</div>
          </li>
          <li class="classification2">
            <div class="numberTotal">
              <div class="number">1</div>
              <div class="squad">个聚集区</div>
            </div>
            <div class="battleArray">昆明市知识产权聚集区</div>
          </li>
          <li class="classification3">
            <div class="numberTotal">
              <div class="number">3</div>
              <div class="squad">大运营中心</div>
            </div>
            <div class="battleArray">
              北京行政中心<br />
              中西部运营中心<br />
              南亚东南亚运营中心
            </div>
          </li>
          <li class="classification4">
            <div class="numberTotal">
              <div class="number">5</div>
              <div class="squad">大服务平台</div>
            </div>
            <div class="battleArray">
              鼎智云IP<br />
              创新大学堂<br />
              西部农业品牌研究院<br />
              北京中振兴农业科技研究院<br />
              中国-南亚东南亚国际技术转移交易网
            </div>
          </li>
          <li class="classification5">
            <div class="numberTotal">
              <div class="number">8</div>
              <div class="squad">大服务领域</div>
            </div>
            <div class="battleArray">
              知识产权代理服务 <br />知识产权咨询服务<br />
              知识产权信息化服务<br />
              知识产权法律服务<br />
              知识产权商用化服务 <br />互联网与科技应用服务<br />
              品牌运营服务<br />
              培训服务
            </div>
          </li>
        </ul>
      </div>
    </div>
    <comFooter />
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgSrc: require("../../static/imgs/regardDH/aboutus.jpg"),
      positionID: this.$route.query.positionID
    };
  },
  mounted() {
    if (this.positionID) {
      document.querySelector("#position" + this.positionID).scrollIntoView(true);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/style/index.scss";

.regardDH {
  background: #fff !important;

  .aboutCenter {
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 5.5rem;
    display: flex;

    .aboutTitle {
      background: url(../../static/imgs/regardDH/bg.png) no-repeat left;
      padding: 2.25rem;
      display: flex;
      align-items: center;

      h1 {
        font-size: 2.25rem;
        color: #333;
        margin-right: 1rem;
      }

      .english {
        font-size: 1rem;
        color: #999;
      }
    }

    .describe {
      font-size: 0.875rem;
      color: #333;
      margin-top: 3.45rem;
      padding-right: 4.375rem;

      p {
        margin-top: 2rem;
        text-indent: 1.8rem;
      }
    }

    .videoFrequency {
      position: relative;

      .aboutPhoto {
        width: 18.75rem;

        img {
          width: 100%;
        }
      }

      .aboutVideo {
        background: #999;
        position: absolute;
        left: 0;
        width: 14.375rem;
        height: 9.375rem;
        bottom: 14%;
      }
    }
  }

  .missionBg {
    background: url(../../static/imgs/regardDH/bg_03_b.jpg) no-repeat bottom;
    padding: 6.5rem 0 4.5rem;
  }

  .missionCenter {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    box-shadow: 0px 0px 16px 2px rgba(4, 0, 0, 0.06);
    margin-top: 3.75rem;

    .mission {
      display: flex;
      background: #fff;
      width: 50%;
      align-items: center;

      .missionPhoto {
        width: 50%;

        img {
          width: 100%;
        }
      }

      .missionDescribe {
        font-size: 0.875rem;
        color: #333;
        width: 50%;
        padding: 0 1.875rem;
        align-items: center;
        position: relative;

        .right {
          position: absolute;
          right: -0.6rem;
          bottom: 50%;
        }

        .left {
          position: absolute;
          left: -0.6rem;
          bottom: 50%;
        }

        .xiantiao {
          width: 1.5rem;
          height: 0.125rem;
          background: #0055a2;
          margin: 1.25rem 0;
        }

        h1 {
          font-size: 1.125rem;
          font-weight: bold;
        }
      }
    }
  }

  .honor {
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 7.5rem;
  }

  .matrixConcent {
    max-width: 1200px;
    margin: 3.5rem auto;
    padding-top: 3.5rem;

    .matrixTitle {
      background: url(../../static/imgs/regardDH/juzhen-01.jpg) no-repeat bottom;
      padding: 3.75rem 0 2.9rem 2.75rem;

      h1 {
        font-size: 2.25rem;
        color: #333;
      }
    }

    .matrixBody {
      background: url(../../static/imgs/regardDH/juzhen-02.jpg) no-repeat top;
      padding: 7.125rem 1rem 2.9rem 1rem;

      .matrixParagraph {
        width: 40%;
        padding-bottom: 8.75rem;
        padding-left: 1.9rem;

        p {
          font-size: 1rem;
          color: #fff;
          width: 100%;
          line-height: 1.6rem;
        }
      }

      .classify {
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        .classification1 {
          background: #fff;
          margin-right: 1.25rem;
          padding: 2.4rem 1.9rem 7.25rem 1.25rem;
          background: url(../../static/imgs/regardDH/icon-1.png) no-repeat top;
        }

        .classification2 {
          background: #fff;
          margin-right: 1.25rem;
          padding: 2.4rem 1.9rem 7.25rem 1.25rem;
          background: url(../../static/imgs/regardDH/icon-2.png) no-repeat top;
        }

        .classification3 {
          background: #fff;
          margin-right: 1.25rem;
          padding: 2.4rem 1.9rem 2.75rem 1.25rem;
          background: url(../../static/imgs/regardDH/icon-3.png) no-repeat top;
        }

        .classification4 {
          background: #fff;
          margin-right: 1.25rem;
          padding: 2.4rem 1.9rem 2.25rem 1.25rem;
          background: url(../../static/imgs/regardDH/icon-4.png) no-repeat top;
        }

        .classification5 {
          background: #fff;
          padding: 2.4rem 1.9rem 2.25rem 1.25rem;
          background: url(../../static/imgs/regardDH/icon-5.png) no-repeat top;
        }

        .numberTotal {
          display: flex;
          align-items: center;
          margin-bottom: 1.25rem;

          .number {
            font-size: 1.75rem;
            color: #fff;
            background: #0055a2;
            width: 2.5rem;
            height: 2.5rem;
            border-radius: 50rem;
            text-align: center;
            margin-right: 0.625rem;
          }

          .squad {
            font-size: 1.25rem;
            color: #0055a2;
            font-weight: bold;
          }
        }

        .battleArray {
          font-size: 0.875rem;
          color: #333;
          line-height: 1.6rem;
        }
      }
    }
  }
}
@media screen and(max-width: 500px) {
	.regardDH{
		width: 100vw;
		.aboutCenter{
			max-width: 100vw;
			display: initial;
			.videoFrequency{
				.aboutPhoto{
					width: 100vw;
				}
				.aboutVideo{
					width: 80vw;
					height: auto;
					margin: 10px auto;
				}
			}
		}
		.missionBg{
			padding: 0 5px;
			width: 100vw;
			.missionCenter{
				max-width: 100vw;
				display: initial;
				.mission{
					width: auto;
				}
			}
		}
		.honor{
			img{
				width: 100vw;
			}
		}
		.matrixConcent{
			max-width: 100vw;
			margin: 10px 0;
			.matrixBody{
			.classify{
				display: initial;
				.classification1,.classification2,.classification3,.classification4{
					    background: url(/assets/img/icon-1.7bba5a97.png) no-repeat 0px;
				}
			}
			}
		}
	}
	
	}
</style>
